var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preserve",domProps:{"innerHTML":_vm._s(_vm.highlightedContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }